var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"number"},_vm._l((6),function(row){return _c('div',{key:`r_${row}`,staticClass:"row"},_vm._l((4),function(col){return _c('Clock',{key:`r_${row}_c_${col}`,ref:"clocks",refInFor:true})}),1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }